import React, { useState } from "react";
import { FaCopy } from "react-icons/fa";
import "./pix.modules.css";

const CopyButton = ({ text }: any) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <>
      <div className="copy-container">
        <p className="copy-text">{text}</p>
        <button
          className={`copy-button ${isCopied ? "copied" : ""}`}
          onClick={handleCopy}
        >
          <FaCopy className="copy-icon" />
          {isCopied ? "Copiado!" : "Copiar"}
        </button>
      </div>
    </>
  );
};

export default CopyButton;
